module.exports = __webpack_public_path__ + "img/netProfitGreen.41eeec6c.png";